export default function KpiCard({ label, value, sub, tone = "neutral", testid }) {
    const toneText = tone === "pos" ? "text-pos" : tone === "neg" ? "text-neg" : "text-ink";
    return (
        <div className="grid-card grid-card-hover p-6 flex flex-col gap-2" data-testid={testid}>
            <div className="overline">{label}</div>
            <div className={`data-num text-3xl font-medium ${toneText}`}>{value}</div>
            {sub ? <div className="text-xs text-muted2">{sub}</div> : null}
        </div>
    );
}
